import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CitySelector from './CitySelector';
import '../css/SearchForm.css';

const API_URL = process.env.REACT_APP_API_URL;

export default function BusinessVideoSelect() {
  const [city, setCity] = useState('');
  const [businesses, setBusinesses] = useState([]);
  const [filteredBusinesses, setFilteredBusinesses] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(''); // ❗ Hata mesajı burada
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!city.trim()) {
      setErrorMessage("Lütfen bir şehir seçin.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${API_URL}/api/business/search?city=${encodeURIComponent(city)}`
      );

      const data = await response.json();

      if (response.ok) {
        setBusinesses(data);
        setFilteredBusinesses(data);

        if (data.length === 0) {
          setErrorMessage("Bu şehirde kayıtlı işletme bulunamadı.");
        }
      } else {
        setErrorMessage(data.message || "İşletmeler bulunamadı.");
      }
    } catch (error) {
      console.error("İşletmeler yüklenemedi:", error);
      setErrorMessage("Bir hata oluştu, lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectBusiness = (businessId) => {
    navigate(`/business-videos/${businessId}`);
  };

  const normalize = (str) =>
    str
      .toLocaleLowerCase('tr')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u')
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/â/g, 'a')
      .replace(/î/g, 'i')
      .replace(/û/g, 'u');

  const handleFilter = (query) => {
    setSearchQuery(query);
    const filtered = businesses.filter((b) =>
      normalize(b.businessName).includes(normalize(query))
    );
    setFilteredBusinesses(filtered);
  };

  return (
    <div className="container my-5">
      <h2 className="text-center text-success mb-2">Maç Videoları</h2>
      <p className="text-center text-muted mb-4">
        Şehir seçin, ardından işletme seçerek maç videolarını görüntüleyin.
      </p>

      {/* Şehir seçimi formu */}
      <form onSubmit={handleSearch} className="mx-auto" style={{ maxWidth: '500px' }}>
        <div className="mb-3">
          <CitySelector selectedCity={city} setSelectedCity={setCity} />
        </div>

        {/* ❗ Hata mesajı burada gösteriliyor */}
        {errorMessage && (
          <p className="text-danger text-center mb-3">{errorMessage}</p>
        )}

        <div className="d-grid">
          <button type="submit" className="btn btn-success rounded-pill" disabled={loading}>
            {loading ? 'Yükleniyor...' : 'İşletmeleri Getir'}
          </button>
        </div>
      </form>

      {/* Arama kutusu */}
      {businesses.length > 0 && (
        <div className="mt-4 mx-auto" style={{ maxWidth: '500px' }}>
          <input
            type="text"
            className="form-control rounded-pill"
            placeholder="İşletme adına göre ara..."
            value={searchQuery}
            onChange={(e) => handleFilter(e.target.value)}
          />
        </div>
      )}

      {/* İşletme kartları */}
      {filteredBusinesses.length > 0 && (
        <div className="row mt-5">
          {filteredBusinesses.map((b) => (
            <div
              key={b._id}
              className="col-md-6 col-lg-4 mb-3"
              onClick={() => handleSelectBusiness(b._id)}
            >
              <div
                className="card shadow-sm border-success h-100 business-card"
                style={{ cursor: 'pointer' }}
              >
                {b.photos && b.photos.length > 0 ? (
                  <img
                    src={`${API_URL}/${b.photos[0]}`}
                    className="card-img-top"
                    alt={b.businessName}
                    style={{ height: '220px', objectFit: 'cover' }}
                  />
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center bg-light"
                    style={{ height: '220px' }}
                  >
                    <span className="text-muted">Fotoğraf Yok</span>
                  </div>
                )}

                <div className="card-body text-center">
                  <h5 className="text-success fw-bold">{b.businessName}</h5>
                  <p className="text-muted mb-1">{b.address}</p>
                  <p className="text-muted small">{b.phone}</p>
                  <button className="btn btn-outline-success rounded-pill">
                    Videoları Gör
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Sonuç yoksa mesaj */}
      {businesses.length > 0 && filteredBusinesses.length === 0 && (
        <p className="text-center text-muted mt-4">
          Aradığınız ada uygun işletme bulunamadı.
        </p>
      )}
    </div>
  );
}
